import moment from "moment-timezone";
import { Hourglass } from "react-loader-spinner";
import { XIcon } from "../../../images/icons/icons";

export const gymData = [
  {
    id: 1,
    name: "WTF Gym Mayur Vihar Phase-3",
    code: "MVP3",
    status: "Active",
    statusType: "success",
    checkins: 39,
    withTrainer: 23,
    utilization: 49,
    utilizationType: "bad",
    trials: 19,
    bcaPending: 5,
    unassigned: 8,
    hourlyMetrics: {
      ratePerHour: 18,
      conversion: 65,
      waitTime: "3m",
    },
  },
  {
    id: 2,
    name: "WTF Gym Sector 116",
    code: "S116",
    status: "Active",
    statusType: "success",
    checkins: 57,
    withTrainer: 34,
    utilization: 75,
    utilizationType: "warn",
    trials: 7,
    bcaPending: 4,
    unassigned: 11,
    hourlyMetrics: {
      ratePerHour: 18,
      conversion: 65,
      waitTime: "3m",
    },
  },
  {
    id: 3,
    name: "WTF Exclusive Gym",
    code: "EXCL",
    status: "Active",
    statusType: "success",
    checkins: 36,
    withTrainer: 21,
    utilization: 88,
    utilizationType: "good",
    trials: 9,
    bcaPending: 10,
    unassigned: 7,
    hourlyMetrics: {
      ratePerHour: 18,
      conversion: 65,
      waitTime: "3m",
    },
  },
  {
    id: 4,
    name: "WTF Gym Sector 10 Dwarka",
    code: "DW10",
    status: "Active",
    statusType: "success",
    checkins: 59,
    withTrainer: 35,
    utilization: 79,
    utilizationType: "warn",
    trials: 18,
    bcaPending: 5,
    unassigned: 12,
    hourlyMetrics: {
      ratePerHour: 18,
      conversion: 65,
      waitTime: "3m",
    },
  },
];

export const analyticsData = {
  trainerAnalysis: {
    booked: 7,
    availableTrainers: 5,
    totalSlots: 12,
    bookedSlots: 7,
    progress: 58,
  },
  trialDistribution: {
    todayTrend: 0,
    days: [
      { label: "Day 1", value: 9, percentage: 75 },
      { label: "Day 2", value: 6, percentage: 50 },
      { label: "Day 3", value: 4, percentage: 33 },
    ],
    totalActiveTrials: 12,
  },
  checkinAnalysis: {
    assigned: 27,
    totalCheckins: 45,
    withTrainer: 27,
    withoutTrainer: 18,
    progress: 60,
  },
};

export const memberData = {
  unassignedMembers: [
    {
      id: 1,
      name: "Member 18",
      time: "16:14",
      trialDay: "Trial Day 3",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 2,
      name: "Member 19",
      time: "16:06",
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: true,
    },
    {
      id: 3,
      name: "Member 20",
      time: "16:07",
      trialDay: "Trial Day 2",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 4,
      name: "Member 21",
      time: "16:25",
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 5,
      name: "Member 22",
      time: null,
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 6,
      name: "Member 23",
      time: "15:45",
      trialDay: "Trial Day 1",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 7,
      name: "Member 24",
      time: "17:20",
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: true,
    },
    {
      id: 8,
      name: "Member 25",
      time: "16:30",
      trialDay: "Trial Day 2",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 9,
      name: "Member 26",
      time: "15:55",
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 10,
      name: "Member 27",
      time: "17:05",
      trialDay: "Trial Day 3",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 11,
      name: "Member 28",
      time: "16:40",
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: true,
    },
    {
      id: 12,
      name: "Member 29",
      time: "15:30",
      trialDay: "Trial Day 1",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
  ],
  trialMembers: [
    {
      id: 1,
      name: "Member 5",
      time: "16:10",
      trialDay: "Trial Day 3",
      status: "assigned",
      trainer: "Trainer 9",
      bcaPending: false,
    },
    {
      id: 2,
      name: "Member 7",
      time: "16:11",
      trialDay: "Trial Day 3",
      status: "assigned",
      trainer: "Trainer 10",
      bcaPending: false,
    },
    {
      id: 3,
      name: "Member 16",
      time: "16:38",
      trialDay: "Trial Day 2",
      status: "assigned",
      trainer: "Trainer 9",
      bcaPending: true,
    },
    {
      id: 4,
      name: "Member 18",
      time: "16:14",
      trialDay: "Trial Day 3",
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 5,
      name: "Member 20",
      time: null,
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: false,
    },
    {
      id: 6,
      name: "Member 30",
      time: "15:20",
      trialDay: "Trial Day 1",
      status: "assigned",
      trainer: "Trainer 5",
      bcaPending: false,
    },
    {
      id: 7,
      name: "Member 31",
      time: "17:15",
      trialDay: "Trial Day 2",
      status: "assigned",
      trainer: "Trainer 7",
      bcaPending: false,
    },
    {
      id: 8,
      name: "Member 32",
      time: "16:45",
      trialDay: "Trial Day 3",
      status: "assigned",
      trainer: "Trainer 8",
      bcaPending: true,
    },
    {
      id: 9,
      name: "Member 33",
      time: "15:35",
      trialDay: "Trial Day 1",
      status: "assigned",
      trainer: "Trainer 6",
      bcaPending: false,
    },
  ],
  bcaPendingMembers: [
    {
      id: 1,
      name: "Member 3",
      time: "16:48",
      trialDay: null,
      status: "assigned",
      trainer: "Trainer 8",
      bcaPending: true,
    },
    {
      id: 2,
      name: "Member 8",
      time: "16:56",
      trialDay: null,
      status: "assigned",
      trainer: "Trainer 9",
      bcaPending: true,
    },
    {
      id: 3,
      name: "Member 15",
      time: "16:45",
      trialDay: null,
      status: "assigned",
      trainer: "Trainer 4",
      bcaPending: true,
    },
    {
      id: 4,
      name: "Member 16",
      time: "16:38",
      trialDay: "Trial Day 2",
      status: "assigned",
      trainer: "Trainer 9",
      bcaPending: true,
    },
    {
      id: 5,
      name: "Member 19",
      time: null,
      trialDay: null,
      status: "unassigned",
      trainer: null,
      bcaPending: true,
    },
    {
      id: 6,
      name: "Member 34",
      time: "17:00",
      trialDay: null,
      status: "assigned",
      trainer: "Trainer 3",
      bcaPending: true,
    },
    {
      id: 7,
      name: "Member 35",
      time: "15:50",
      trialDay: "Trial Day 1",
      status: "assigned",
      trainer: "Trainer 2",
      bcaPending: true,
    },
  ],
};

export const getCheckinsIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx={9} cy={7} r={4} />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
};

export const getWithTrainerIcon = (classname = "") => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={classname}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx={9} cy={7} r={4} />
      <path d="m16 11 2 2 4-4" />
    </svg>
  );
};

export const getTrialsIcon = (classname = "") => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={classname}
    >
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  );
};

export const getBCAPendingIcon = (classname = "") => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={classname}
    >
      <circle cx={12} cy={12} r={10} />
      <path d="M12 6v6l4 2" />
    </svg>
  );
};

export const getUnassignedIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx={12} cy={12} r={10} />
      <path d="M12 8v4" />
      <path d="M12 16h.01" />
    </svg>
  );
};

export const getHourlyIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path
        d="M13 2l-2 5 5-2M12 8v4l3 3"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const getChevronIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path
        d="M9 5l7 7-7 7"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const getUtilizationIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  );
};

export const getBuildingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label="Trainer Analysis icon"
    >
      <rect x={3} y={3} width={18} height={18} rx={4} />
      <g fill="currentColor" stroke="none">
        <circle cx={8} cy={8} r="1.25" />
        <circle cx={12} cy={8} r="1.25" />
        <circle cx={16} cy={8} r="1.25" />
        <circle cx={8} cy={12} r="1.25" />
        <circle cx={12} cy={12} r="1.25" />
        <circle cx={16} cy={12} r="1.25" />
        <circle cx={8} cy={16} r="1.25" />
        <circle cx={12} cy={16} r="1.25" />
        <circle cx={16} cy={16} r="1.25" />
      </g>
      <rect
        x={10}
        y={18}
        width={4}
        height="1.5"
        rx="0.75"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
};

export const getRightArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
};

export const getCrossTickIcon = () => {
  return (
    <svg
      className="mr-member-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <circle cx="12" cy="12" r="10" strokeWidth="2" />
      <line x1="15" y1="9" x2="9" y2="15" strokeWidth="2" />
      <line x1="9" y1="9" x2="15" y2="15" strokeWidth="2" />
    </svg>
  );
};

export const getPersonIcon = () => {
  return (
    <svg
      className="mr-member-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
    >
      <circle cx="12" cy="7" r="4" strokeWidth="2" />
      <path d="M20 21a8 8 0 1 0-16 0" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export const getAssignIcon = () => {
  return (
    <svg
      className="mr-member-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
};

export const getViewIcon = () => {
  return (
    <svg
      className="mr-member-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

export const getTrialAssignIcon = () => {
  return (
    <svg
      className="mr-member-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" />
    </svg>
  );
};

export const getWaveIcon = () => {
  return (
    <svg
      className="mr-badge__icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        d="M3 17l6-6 4 4 8-8"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const getFreshMemberIcon = () => {
  return (
    <svg
      className="mr-member-type-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      <circle cx="18" cy="6" r="3" fill="currentColor" stroke="none" />
    </svg>
  );
};

export const getExistingMemberIcon = () => {
  return (
    <svg
      className="mr-member-type-icon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      <path d="M20 8v6l-3-2" />
    </svg>
  );
};

export const getCardIcon = (key) => {
  switch (key) {
    case "total_checkins":
      return getCheckinsIcon();
    case "with_trainer":
    case "trainer_attendance":
      return getWithTrainerIcon();
    case "bca_pending":
      return getBCAPendingIcon();
    case "unassigned":
      return getUnassignedIcon();
    case "active_trials":
    case "pt_trial_pending":
      return getTrialsIcon();
    case "trainer_avg_utilization":
      return getUtilizationIcon();
    case "pt_trial_inprogress":
      return <Hourglass />;
    case "pt_trial_not_initiated":
      return <XIcon />;
    default:
      return getCheckinsIcon();
  }
};

export const getCardIconType = (key) => {
  switch (key) {
    case "total_checkins":
      return "info";
    case "with_trainer":
      return "success";
    case "bca_pending":
      return "warning";
    case "unassigned":
    case "pt_trial_not_initiated":
      return "danger";
    case "active_trials":
      return "info";
    case "trainer_avg_utilization":
      return "warning";
    default:
      return "info";
  }
};

export const getUtilizationType = (utilization = 0) => {
  if (utilization < 50) return "bad";
  if (utilization < 80) return "warn";
  return "good";
};

export const getChangeType = (changeType) => {
  if (changeType === "negative") return "down";
  if (changeType === "positive") return "up";
  return "flat";
};

export const getCardTitle = (key) => {
  const titles = {
    total_checkins: "Total Check-ins",
    with_trainer: "With Trainer",
    bca_pending: "BCA Pending",
    unassigned: "Unassigned",
    active_trials: "Active Trials",
    trainer_avg_utilization: "Avg Trainer Utilization",
    pt_trial_pending: "PT Trial Pending",
    pt_trial_not_initiated: "Not Initiated PT Trials",
    pt_trial_inprogress: "Ongoing PT Trials",
  };
  return titles[key] || key?.replace(/_/g, " ");
};

export const getCardValue = (key, value) => {
  switch (key) {
    case "trainer_attendance":
      return `${value?.present || 0}/${value?.total || 0}`;
    default:
      return value || 0;
  }
};

export const getSubLabel = (key, value) => {
  switch (key) {
    case "trainer_attendance":
      return `${value?.absent || 0} absent`;
    default:
      return value || 0;
  }
};

export const getCommaSeparatedValues = (array) => {
  if (!array || !Array.isArray(array) || array.length === 0) {
    return "";
  }

  const values = array
    .filter((item) => item && item.value)
    .map((item) => item.value);

  return values.join(",");
};

export const formatSelectedDate = (dateString) => {
  if (!dateString) return null;
  return moment(dateString).format("MMM DD, YYYY");
};

export const formatSelectedTimeSlots = (timeSlots) => {
  if (!timeSlots || !Array.isArray(timeSlots) || timeSlots.length === 0) {
    return null;
  }
  return timeSlots.map((slot) => slot.label).join(", ");
};

export const memberTypeOptions = [
  {
    label: "Fresh Member",
    value: "fresh_member",
    icon: getFreshMemberIcon(),
    description: "New members",
  },
  {
    label: "Existing Member",
    value: "existing_member",
    icon: getExistingMemberIcon(),
    description: "Returning members",
  },
];
